import { allocationsAt, loadOf, monthLabel, safeDiv, type Staff } from '@kdk/shared';
import { tokens } from '@kdk/shared/theme';
import { Box } from '@mui/material';
import { caseColor } from './caseColor';

type Props = { staff: Staff; month: number; width?: number };

/** その月の案件別配分を積み上げた帯。100% を超えると白い線で 100% の位置を示す。 */
export const AllocationBar = ({ staff, month, width = 120 }: Props) => {
  const load = loadOf(staff, month);
  const scale = Math.max(100, load);
  return (
    <Box
      component="span"
      role="img"
      aria-label={`${monthLabel(month)}の配分合計 ${load}%`}
      sx={{
        display: 'inline-flex',
        position: 'relative',
        width,
        height: 10,
        borderRadius: '2px',
        overflow: 'hidden',
        bgcolor: tokens.track,
        verticalAlign: 'middle',
      }}
    >
      {allocationsAt(staff, month).map((a, i) => (
        <Box
          key={`${a.caseId}-${i}`}
          component="i"
          title={`${a.caseId} ${a.percent}%`}
          sx={{ width: `${safeDiv(a.percent, scale) * 100}%`, bgcolor: caseColor(a.caseId) }}
        />
      ))}
      {load > 100 && (
        <Box
          component="b"
          sx={{
            position: 'absolute',
            left: `${safeDiv(100, scale) * 100}%`,
            top: -2,
            bottom: -2,
            width: 2,
            bgcolor: tokens.marker,
          }}
        />
      )}
    </Box>
  );
};
